export default "__VITE_ASSET__DYSDPyJy__"